<lvr-heading>
	{{ 'workplace.workplace_view.title' | transloco }}
	{{ institution().name }}
</lvr-heading>

@if (canCreateWorkplace()) {
	<lvr-button
		variant="primary"
		[label]="'workplace.workplace_view.workplace' | transloco"
		[ariaLabel]="'base.button.add_workplace' | transloco"
		[type]="'button'"
		(clicked)="openCreate()"
		data-testid="add-button"
		icon="add"
	>
	</lvr-button>
}

@if (institution()) {
	<lvr-workplace-list
		[institutionId]="institution().id"
		[institutionName]="institution().name"
		[user]="user()"
		[page]="page()"
		(pageRequested)="onPageRequested($event)"
	></lvr-workplace-list>
}
